// test888
(888 && 0);
